import BaseApiService from './BaseApiService.js';

class TimetableService extends BaseApiService {

  // ✅ Get all timetables for authenticated tenant
  async getTimetables() {
    try {
      return await this.makeRequest('/api/timetables', { method: 'GET' });
    } catch (error) {
      console.error('Failed to fetch timetables:', error);
      return [];
    }
  }

  // ✅ Get timetable by Class and Section
  async getTimetableByClassAndSection(className, section, academicYear = '2026-2027') {
    try {
      const url = `/api/timetables/by-class-section?className=${encodeURIComponent(className)}&section=${encodeURIComponent(section)}&academicYear=${encodeURIComponent(academicYear)}`;
      return await this.makeRequest(url, { method: 'GET' });
    } catch (error) {
      console.error(`Failed to fetch timetable for ${className} ${section}:`, error);
      return null;
    }
  }

  // ✅ Pre-check teacher slot conflict (Advisory UX)
  async checkTeacherConflict(params) {
    try {
      return await this.makeRequest('/api/timetables/check-conflict', {
        method: 'POST',
        body: JSON.stringify(params)
      });
    } catch (error) {
      console.error('Failed to check teacher conflict:', error);
      return { hasConflict: false };
    }
  }

  // ✅ Save Timetable Draft (with backend conflict validation)
  async saveTimetableDraft(timetableData) {
    return this.makeRequest('/api/timetables/save-draft', {
      method: 'POST',
      body: JSON.stringify(timetableData)
    });
  }

  // ✅ Publish Timetable (Atomic transaction)
  async publishTimetable(timetableId) {
    return this.makeRequest(`/api/timetables/publish/${timetableId}`, {
      method: 'POST'
    });
  }

  // ✅ Get configured Bell Schedules
  async getBellSchedules(academicYear = '2026-2027') {
    try {
      const url = `/api/bell-schedules?academicYear=${encodeURIComponent(academicYear)}`;
      return await this.makeRequest(url, { method: 'GET' });
    } catch (error) {
      console.error('Failed to fetch bell schedules:', error);
      return [];
    }
  }

  // ✅ Create/Update Bell Schedule
  async saveBellSchedule(bellScheduleData) {
    return this.makeRequest('/api/bell-schedules/create', {
      method: 'POST',
      body: JSON.stringify(bellScheduleData)
    });
  }
}

const timetableService = new TimetableService();
export default timetableService;
